<template>
    <administrative>
        <card-header :title="'Branch: '+branch.title+' - '+branch.code"/>
        <div class="grid grid-cols-2 gap-4">
            <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg">
                <loading :showLoading="form.processing"/>
                <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                    <p class="text-lg font-medium mb-4">Add User</p>
                    <form @submit.prevent="submitForm">
                        <div class="grid grid-cols-8 gap-4 mb-4">
                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :required="true" :value="'Name'"/>
                                <breeze-input required v-model="form.name" class="w-full"/>
                                <breeze-input-error :message="form.errors.addUser?form.errors.addUser.name:''"/>
                            </div>
                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :required="true" :value="'Mobile'"/>
                                <breeze-input required type="number" v-model="form.mobile" class="w-full"/>
                                <breeze-input-error :message="form.errors.addUser?form.errors.addUser.mobile:''"/>
                            </div>
                            <div class="col-span-8 sm:col-span-8">
                                <breeze-label :required="true" :value="'Email'"/>
                                <breeze-input required v-model="form.email" class="w-full"/>
                                <breeze-input-error :message="form.errors.addUser?form.errors.addUser.email:''"/>
                            </div>
                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :value="'Date Of Birth'"/>
                                <breeze-input v-model="form.date_of_birth" type="date" class="w-full"/>
                                <breeze-input-error
                                    :message="form.errors.addUser?form.errors.addUser.date_of_birth:''"
                                />
                            </div>

                            <div class="col-span-4 sm:col-span-4">
                                <breeze-label :value="'Blood Group'"/>
                                <breeze-input v-model="form.blood_group" type="text" class="w-full"/>
                                <breeze-input-error
                                    :message="form.errors.addUser?form.errors.addUser.blood_group:''"
                                />
                            </div>
                            <div class="col-span-8 sm:col-span-8">
                                <FormMultiselect
                                    label="Role"
                                    :options="roles"
                                    track-key="id"
                                    label-key="name"
                                    :object="true"
                                    v-model="form.role"
                                    :placeholder="'Select Role'"
                                    :required="true"
                                    :error="form.errors?.addUser?.role"
                                />
                            </div>
                        </div>
                        <button-link
                            :href="route('administrative.branch.list')"
                            class="bg-red-500 mr-4 hover:bg-red-400"
                        >Cancel
                        </button-link>
                        <breeze-button :disabled="form.processing">Save</breeze-button>
                        <exception/>
                    </form>
                </div>
            </div>
            <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg">
                <loading :showLoading="selectform.processing"/>
                <div :class="{'opacity-50':selectform.processing,'opacity-100':!selectform.processing}">
                    <p class="text-lg font-medium mb-4">Branch Users</p>
                    <form @submit.prevent="assignUsers">
                        <div>
                            <div
                                class="grid grid-cols-8 gap-4 mb-4 items-center"
                                v-for="(user,index) in selectform.users"
                                :key="index"
                            >
                                <div class="col-span-7 sm:col-span-7">
                                    <FormMultiselect
                                        label="Select User"
                                        :options="users"
                                        track-key="id"
                                        label-key="name"
                                        :object="true"
                                        v-model="selectform.users[index]"
                                        :placeholder="'Select User'"
                                        :error="selectform.errors?.addUser?selectform?.errors?.addUser[`users.${index}.id`]:''"
                                    />
                                </div>

                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="h-6 w-6 text-red-500 justify-self-center cursor-pointer"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    @click="removeUser(index)"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </div>
                            <breeze-button :type="'button'" class="my-4" @click="addUser">Add</breeze-button>
                        </div>

                        <button-link
                            :href="route('administrative.branch.list')"
                            class="bg-red-500 mr-4 hover:bg-red-400"
                        >Cancel
                        </button-link>
                        <breeze-button :disabled="form.processing">Next</breeze-button>
                        <exception/>
                    </form>
                </div>
            </div>
        </div>
    </administrative>
</template>

<script>
import Administrative from "@/Pages/Administrative/Administrative";
import BreezeTable from "@/Components/Table";
import BreezeInput from "@/Components/Input";
import BreezeLabel from "@/Components/Label";
import BreezeButton from "@/Components/Button";
import BreezeInputError from "@/Components/InputError";
import ButtonLink from "@/Components/ButtonLink";
import SelectList from "@/Components/SelectList";
import Exception from "@/Components/Exception";
import {useForm} from "@inertiajs/inertia-vue3";
import CardHeader from "@/Components/CardHeader";
import Loading from "@/Components/Loading";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";

export default {
    components: {
        FormMultiselect,
        Administrative,
        BreezeTable,
        ButtonLink,
        Exception,
        BreezeInputError,
        BreezeInput,
        BreezeLabel,
        BreezeButton,
        SelectList,
        CardHeader,
        Loading
    },
    props: ["branch", "users", "roles"],
    data() {
        return {
            form: useForm(
                {
                    name: "",
                    mobile: "",
                    email: "",
                    blood_group: "",
                    date_of_birth: "",
                    role: ""
                },
                {
                    errorBag: "addUser"
                }
            ),
            selectform: useForm(
                {
                    _method: "PUT",
                    users: this.branch.users
                },
                {
                    errorBag: "assignUsers"
                }
            )
        };
    },
    methods: {
        submitForm() {
            this.form.post(
                route("administrative.branch.admin.store", this.branch.id),
                {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.form.reset();
                        location.reload();
                    }
                }
            );
        },
        assignUsers() {
            this.selectform.post(
                route("administrative.branch.admin.update", this.branch.id),
                {
                    preserveScroll: true,
                    onSuccess: () => this.selectform.reset()
                }
            );
        },
        addUser() {
            this.selectform.users.push({});
        },
        removeUser(index) {
            this.selectform.users.splice(index, 1);
        }
    }

};
</script>
